import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  paddingTabs: {
    padding: "2em",
    // overflow: "auto",
    [theme.breakpoints.only("xs")]: {
      padding: "1em",
    },
  },
  buttons: {
    display: "flex",
    justifyContent: "end",
  },
}))

export default useStyles
